module.exports = __webpack_public_path__ + "static/media/baleine2-big.a4fb8525.png";